module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"regionsCarbonTableCard.title":"Region emissions this month","regionsCarbonTableCard.subtitle":"All regions visible within this tenant"}}')
  delete Component.options._Ctor
}
